import { apiRequest } from './auth';

export const qualityAPI = {
  getAll: async () => {
    return await apiRequest('/quality');
  },

  getByProject: async (project) => {
    return await apiRequest(`/quality/project/${encodeURIComponent(project)}`);
  },

  getById: async (id) => {
    return await apiRequest(`/quality/${id}`);
  },

  create: async (qualityData) => {
    return await apiRequest('/quality', {
      method: 'POST',
      body: JSON.stringify(qualityData),
    });
  },

  update: async (id, qualityData) => {
    return await apiRequest(`/quality/${id}`, {
      method: 'PUT',
      body: JSON.stringify(qualityData),
    });
  },

  delete: async (id) => {
    return await apiRequest(`/quality/${id}`, {
      method: 'DELETE',
    });
  }
};

export default qualityAPI;
